module.exports = __webpack_public_path__ + "img/2.4b0dd003.jpg";